import fetch from "auth/FetchInterceptor";

export const ProductService = {};

ProductService.get = async ({
  page,
  pageSize,
  sort,
  searchText,
  state = null,
}) => {
  let apiUrl = "/v1/product?page=" + page + "&per_page=" + pageSize;
  if (sort === "ascend") apiUrl += "&order_by=%2Dname";
  else if (sort === "descend") apiUrl += "&order_by=%2Bname";
  if (searchText) apiUrl += "&name=" + searchText;
  if (state) {
    apiUrl += "&state=" + state;
  }
  return fetch({
    url: apiUrl,
    method: "get",
  });
};

ProductService.getById = async (id) => {
  const apiUrl = `/v1/product/${id}`;
  return fetch({
    url: apiUrl,
    method: "get",
  });
};

ProductService.getImage = async (id) => {
  const apiUrl = `/v1/product/${id}/image`;
  return fetch({
    url: apiUrl,
    method: "get",
    responseType: "blob",
  });
};

ProductService.createProduct = async (data) => {
  const apiUrl = `/v1/product`;
  const form_data = new FormData();

  form_data.append("type", data.type);
  form_data.append("name", data.name);
  if (data.days_before_expired)
    form_data.append("days_before_expired", data.days_before_expired);
  form_data.append("store_price", data.store_price);
  form_data.append("ecommerce_price_gof", data.ecommerce_price_gof);
  form_data.append("ecommerce_price_gbf", data.ecommerce_price_gbf);
  form_data.append("ecommerce_price_spf", data.ecommerce_price_spf);
  form_data.append("ecommerce_price_tkp", data.ecommerce_price_tkp);
  form_data.append("ecommerce_price_spe", data.ecommerce_price_spe);
  form_data.append("ecommerce_price_tts", data.ecommerce_price_tts);
  form_data.append("ecommerce_price_qpn", data.ecommerce_price_qpn);
  form_data.append("loyalty_point", data.loyalty_point);
  form_data.append("category", data.category);
  form_data.append("image", data.image);

  return fetch({
    url: apiUrl,
    method: "post",
    data: form_data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

ProductService.updateProduct = async (data) => {
  const apiUrl = `/v1/product/${data.id}`;
  const form_data = new FormData();

  form_data.append("type", data.type);
  form_data.append("name", data.name);
  if (data.days_before_expired)
    form_data.append("days_before_expired", data.days_before_expired);
  form_data.append("store_price", data.store_price);
  form_data.append("ecommerce_price_gof", data.ecommerce_price_gof);
  form_data.append("ecommerce_price_gbf", data.ecommerce_price_gbf);
  form_data.append("ecommerce_price_spf", data.ecommerce_price_spf);
  form_data.append("ecommerce_price_tkp", data.ecommerce_price_tkp);
  form_data.append("ecommerce_price_spe", data.ecommerce_price_spe);
  form_data.append("ecommerce_price_tts", data.ecommerce_price_tts);
  form_data.append("ecommerce_price_qpn", data.ecommerce_price_qpn);
  form_data.append("loyalty_point", data.loyalty_point);
  form_data.append("category", data.category);
  form_data.append("image", data.image);

  return fetch({
    url: apiUrl,
    method: "post",
    data: form_data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

ProductService.deleteProduct = async (id, confirm = false) => {
  let apiUrl = `/v1/product/${id}`;
  if (confirm) apiUrl = `/v1/product/${id}?confirmed`;
  return fetch({
    url: apiUrl,
    method: "delete",
  });
};

export default ProductService;
